import { render, staticRenderFns } from "./AnnexeIIView.vue?vue&type=template&id=04b88a14"
import script from "./AnnexeIIView.vue?vue&type=script&lang=js"
export * from "./AnnexeIIView.vue?vue&type=script&lang=js"
import style0 from "./AnnexeIIView.vue?vue&type=style&index=0&id=04b88a14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports